import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import events from '@gd/event-bus'
import merge from 'deepmerge'
import { marked } from 'marked'
import { Ref, computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import file from '../rules/kno.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'RuleKno',
  emits: ['link', 'loaded'],
  setup(__props, { emit }) {

const { t, messages, setLocaleMessage } = useI18n()


const rulesText = ref(null)

const text = computed(() => {
  return marked(t('main.rules_md') as string)
})

Object.keys(file).forEach((lang) => {
  const obj = merge(messages.value[lang] || {}, (file as { [key: string]: any })[lang])
  setLocaleMessage(lang, obj)
})

onMounted(() => {
  emit('loaded')
})

const clickListener = (e: Event) => {
  const target = e.target as HTMLLinkElement
  if (target?.tagName === 'A') {
    if (target?.href && /#consent-settings/.test(target?.href)) {
      events.$emit('consent-settings')
    }
  }
  e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!

  return (_openBlock(), _createBlock(_component_t_text, {
    ref_key: "rulesText",
    ref: rulesText,
    class: "rules",
    innerHTML: text.value,
    onClick: clickListener
  }, null, 8, ["innerHTML"]))
}
}

})